import { History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { useTemplateVersions } from '@/api/hooks/useTemplateVersions';

interface Props {
  templateId: string;
}

export function TemplateVersionList({ templateId }: Props) {
  const { data: versions, isLoading } = useTemplateVersions(templateId);

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <History className="h-4 w-4 text-text-secondary" />
          <CardTitle className="text-sm">Version History</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-full" />
            ))}
          </div>
        ) : !versions || versions.length === 0 ? (
          <p className="text-xs text-text-muted">No versions published yet.</p>
        ) : (
          <div className="space-y-1.5">
            {versions.map((v) => (
              <div
                key={v.id}
                className="flex items-center justify-between py-1.5 px-2 rounded hover:bg-bg-hover"
              >
                <div className="flex items-center gap-2">
                  <span className="text-xs font-mono text-text-primary">v{v.version_number}</span>
                  {v.is_current && (
                    <Badge variant="sky" className="text-[10px] py-0">current</Badge>
                  )}
                </div>
                <span className="text-[10px] text-text-muted">
                  {new Date(v.published_at).toLocaleDateString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
